import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
import LabelModel from '../../models/LabelModel';
/**
 *
 * @param labelModel LabelModel
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (labelModel, organisationId) {
    var labelModelClone = new LabelModel(labelModel);
    labelModelClone.color = labelModel.getHexColor(); // convert to hex
    var url = applyPathVariables(EndPoints.ORGANISATION_LABELS, { organisationId: organisationId });
    var request = new Request({
        method: Methods.POST,
        url: url,
        withCredentials: true,
        data: labelModelClone
    });
    return request.execute();
});
